// extracted by mini-css-extract-plugin
export default {"footer-container":"Y0aN"};